import React, { useEffect } from 'react'
import Logo from '../../images/logo.png';
import chooseImage from '../../images/chooseImage.jpg';
import './Choose.css'
import Aos from 'aos';
import 'aos/dist/aos.css';
const Choose = () => {
    useEffect(() => {
        Aos.init({ duration: 2000 });
    }, [])

    return (
        <div className='choose' id='choose' data-aos='fade-up'>
            <div className='choose__section'>
                <p>Why Choose</p>
                <img src={Logo} alt='retbin' />
            </div>
            <div className='choose__border'></div>

            <div className='choose__content'>
                <div className='choose__left'>
                    {/* Timeline */}
                    <div className="choose__container">
                        <div className="timeline">
                            <ul>
                                <li>
                                    <div className="bullet pink"></div>
                                    <div className="time">1st</div>
                                    <div className="desc">
                                        <h3>First, we learn about your business challenges, concern and opportunities</h3>
                                    </div>
                                </li>
                                <li>
                                    <div className="bullet green"></div>
                                    <div className="time">2nd</div>
                                    <div className="desc">
                                        <h3>Then we design and implement a customer solutions designed specifically to address your needs</h3>

                                    </div>
                                </li>
                                <li>
                                    <div className="bullet orange"></div>
                                    <div className="time">3rd</div>
                                    <div className="desc">
                                        <h3>Once implemented, we manage it all for a low fixed monthly cost</h3>
                                    </div>
                                </li>
                                <li>
                                    <div className="bullet addition"></div>
                                    <div className="time">4th</div>
                                    <div className="desc">
                                        <h3>We are here for you and looking to establish long term business relationship with our client.</h3>

                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    {/* Timeline */}
                </div>
                <div className='choose__right'>
                    <img src={chooseImage} alt='retbin' />
                </div>
            </div>
        </div>
    )
}

export default Choose
